import TableTools from "@/utils/tableTools";
import mesureEnum from "@/model/mesureEnum";
import dimensionEnum from "@/model/dimensionEnum";
import {
  columnTypeEnum,
  calculatedColumnsEnum,
  alternativeColumnLabelEnum,
} from "@/model/columnsEnums";
import { kioskGlobalHelper } from "@/utils/kioskGlobalHelperUpdated";

export default {
  namespaced: true,
  state: {
    dimensionColumnsTables: [],
    measureColumnsTables: [],
    defaultSortedColumnTables: "",
    tablesData: [],
    dataReadyTables: false,
  },
  mutations: {
    setDimensionColumnsTables(state, data) {
      state.dimensionColumnsTables = data;
    },
    setMeasureColumnsTables(state, data) {
      state.measureColumnsTables = data;
    },
    setDefaultSortedColumnTables(state, data) {
      state.defaultSortedColumnTables = data;
    },
    setTablesData(state, data) {
      state.tablesData = data;
    },
    updateTableData(state, payload) {
      state.tablesData = state.tablesData.map((tab) => {
        if (tab.tableHeaderId === payload.siteId) {
          return {
            ...tab,
            dataTable: payload.dataTable,
            totalsData: payload.totalsData,
          };
        }
        return tab;
      });
    },
    setDataReadyTables(state, data) {
      state.dataReadyTables = data;
    },
  },
  actions: {
    resetDataReadyTables({ commit }) {
      commit("setDataReadyTables", false);
    },
    initDisplayTables({ commit }) {
      commit(
        "setDimensionColumnsTables",
        TableTools.Helper.constructColumnTable(
          [
            dimensionEnum.DATE,
            dimensionEnum.KIOSK_NAME
          ],
          null,
          columnTypeEnum.DIMENSION,
          false,
          null
        )
      );

      commit(
        "setMeasureColumnsTables",
        TableTools.Helper.constructColumnTable(
          [
            mesureEnum.PURCHASEHISTORY_AMOUNTCB,
            mesureEnum.PURCHASEHISTORY_AMOUNTCASH,
            alternativeColumnLabelEnum.SNACKHISTORY_AMOUNT_CB_TTC,
          ],
          null,
          columnTypeEnum.MEASURE,
          false,
          null
        )
      );

      //commit("setDefaultSortedColumnTables", dimensionEnum.KIOSK_NAME);
    },
    async updateTableList({ state, commit, dispatch }, payload) {
      // Initialisation des objets contenant toutes les données pour chaque site :
      // permet d'afficher dès maintenant les entêtes de tableaux et le loader pour indiquer que les requêtes sont en cours
      const tablesData = payload.siteValues.map((site, i) => {
        return {
          tableNumber: i.toString(),
          tableHeader: site.label,
          tableHeaderId: site.id,
          dataTable: [],
          totalsData: {},
        };
      });
      commit("setTablesData", tablesData);

      const queries = kioskGlobalHelper.getQueries(payload.filters, payload.timeDimension);

      const resultSets = await TableTools.Helper.doMultipleRequest(queries);
      const mergedResults = TableTools.Helper.mergeResultsByCommonDimensions(
        resultSets,
        kioskGlobalHelper.dimensions,
        kioskGlobalHelper.orderByColumns
      );

      await dispatch('initDisplayTables');

      // Complétion des objets avec les données reçues pour chaque site
      payload.siteValues.forEach((site) => {
        let dataTable = mergedResults.filter(
          (result) => result[dimensionEnum.SITE] === site.id
        );

        // Extraire la devise spécifique à ce site
        const siteCurrency = dataTable.length > 0 ? (dataTable[0][dimensionEnum.SITE_CURRENCY] || 'EUR') : 'EUR';

        dataTable = kioskGlobalHelper.addSnackHistoryCbColumns(dataTable);
        const totalsData = TableTools.Helper.calculateTotalsData(
          dataTable,
          state.measureColumnsTables
            .map((col) => col.key)
            .filter(
              (key) => key != calculatedColumnsEnum.TOTAL_REVENUE_PERCENT_SITE
            )
        );
        //Ajout des lignes de groupement
        dataTable = TableTools.Helper.addGroupRows(
          dataTable,
          [dimensionEnum.DATE],
          [
            alternativeColumnLabelEnum.SNACKHISTORY_AMOUNT_CB_TTC,
            mesureEnum.PURCHASEHISTORY_AMOUNTCB,
            mesureEnum.PURCHASEHISTORY_AMOUNTCASH,
            mesureEnum.GAMEHISTORY_TOKEN_PRICE,
          ]
        );
        // Ajout de la devise aux lignes
        dataTable.forEach(row => {
          row["Site.currency"] = siteCurrency;
        });
        dataTable = kioskGlobalHelper.addPercentageColumn(
          dataTable,
          totalsData[calculatedColumnsEnum.RECEIPTS_TOTAL_AMOUNT]
        );
        commit("updateTableData", { siteId: site.id, dataTable, totalsData });
      });
      commit("setDataReadyTables", true);
    },
  },
};
